// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"433":"838c28f9","895":"bb839da6"}[chunkId] + ".css";
};